import React from "react"
import cx from "classnames"

type Props = {
  id?: string
  className?: string
  children: JSX.Element | JSX.Element[]
}

const PageSubheading = ({ id, className, children }: Props) => {
  return (
    <div id={id} className={cx(className)}>
      {children}
    </div>
  )
}

export default PageSubheading
